
import {parseISO, format, parse} from 'date-fns';
import { dispatchData } from './dispatchData';

import { api } from '@/utils/http';
var CryptoJS = require('crypto-js');
const WORD_CRYPTO = 'cEDv10OMn4Jt'

export const encryptText = (txt) => {
  let K = WORD_CRYPTO;
  let ciphertext = CryptoJS.AES.encrypt(JSON.stringify(txt), K).toString();
  const urlSafeEncrypted = ciphertext
        .replace(/\+/g, '-') // Substitui '+' por '-'
        .replace(/\//g, '_') // Substitui '/' por '_'
        .replace(/=+$/, ''); // Remove os '=' do final (padding)
  return urlSafeEncrypted;
};
export const decryptText = (txt) => {
  const base64 = txt
  .replace(/-/g, '+') // Substitui '-' de volta para '+'
  .replace(/_/g, '/'); // Substitui '_' de volta para '/'
  let K = WORD_CRYPTO;
  var bytes = CryptoJS.AES.decrypt(base64, K);
  var decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  return decryptedData;
};
export const formatDateDB = (value) => {
  if (!value) return '-';
  try {
    const date = parseISO(value); 
    return format(date, 'dd/MM/yyyy'); 
  } catch (error) {
    console.error('Data inválida:', value);
    return '-';
  }
};
export const formatDatePT = (value) => {
  if (!value) return '-';
  try {    
    return format(value, 'dd/MM/yyyy'); // Retorna no formato desejado
  } catch (error) {
    console.error('Data inválida:', value);
    return '-';
  }
};
export const formatDateToDB = (dateStr) => {
  try {
    const parsed = parse(dateStr, 'dd/MM/yyyy', new Date());
    return format(parsed, 'yyyy-MM-dd');
  } catch (err) {
    console.error('Erro ao converter data:', dateStr);
    return null;
  }
};

export const FlashMessageHeader = (messageHeader, colorBackHeader, callback) => {
 
  sendMessageFN(messageHeader, colorBackHeader);
  setTimeout(() => {
    closeMessageFN();
  }, 2500);
  if (callback) {
    setTimeout(() => {
      if (typeof callback === 'function') {
        callback(); // Executa a função passada como argumento
      } else {
        console.error('Callback não é uma função válida');
      }
    }, 2800);
  }
};
const sendMessageFN = (messageHeader, typeNotification) => {
  
  const data = {
    activeMessageHeader: true,
    typeNotification,
    messageHeader,
  };
  dispatchData('MESSAGE_HEADER_OPEN', data);
};
const closeMessageFN = () => {
  const data = {
    activeMessageHeader: false,
    typeNotification: '',
    messageHeader: '',
  };
  dispatchData('MESSAGE_HEADER_CLOSE', data);
};
function normalizeString(str) {
  return str
    .normalize("NFD") // Decompõe acentos
    .replace(/[\u0300-\u036f]/g, "") // Remove marcas diacríticas
    .replace(/[^\w\s]/gi, "") // Remove caracteres especiais
    .toLowerCase()
    .trim();
}

export const filterFn = (images, query) => {
  const normalizedQuery = normalizeString(query);

  return images.filter((img) => {
    const normalizedName = normalizeString(img.name);
    return normalizedQuery
      .split(" ")
      .every((word) => normalizedName.includes(word));
  });
};
export const postServer = async (url, data = {}) => {
 
  const resp = await api.post(`${url}`, data, {
    headers: { 'Content-Type': 'application/json' },
    withCredentials: true, // garante que os cookies sejam apagados no logout
  }); 

  return resp.data;
};